<script lang="ts" setup>
import { AppTypography } from './index';

const { title = '', subtitle = '' } = defineProps<{
  title?: string;
  subtitle?: string;
}>();
</script>

<template>
  <v-card flat max-width="610" width="100%">
    <v-card-item v-if="title || subtitle" class="text-center">
      <v-card-title v-if="title">
        <AppTypography element="h4">{{ title }}</AppTypography>
      </v-card-title>
      <v-card-subtitle v-if="$slots.subtitle || subtitle">
        <slot name="subtitle">
          <AppTypography>{{ subtitle }}</AppTypography>
        </slot>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/_spacing.scss' as *;
@use '~/assets/scss/_variables.scss' as *;

.v-card {
  padding: 56px 0;
  border-radius: 16px;

  @media (min-width: 768px) {
    padding: 56px;
  }
}

.v-card-title {
  white-space: normal;
  h4 {
    line-height: normal;
  }
}

.v-card-subtitle {
  white-space: normal;
  padding: 0 !important;
  opacity: 1;
}

.v-card-text {
  padding: 0;
}
.v-card {
  border-radius: 16px;
  border: 1px solid $border-default;
}

.v-card-item {
  padding: 0 !important;

  :deep(.v-card-item__content) {
    display: flex;
    flex-direction: column;
    gap: $spacing-sm;
  }
}
</style>
